// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Vp7-","notes":"Notes_notes__1PtIM"};